// import "./index.scss";
import LoginPageLyout from "@layouts/login";
import { useState, useRef } from "react";
import { adminLogin } from "@services/auth.service";
import { NavLink } from "react-router-dom";
import { getValue } from "@utils/lodash";
import SimpleReactValidator from "simple-react-validator";
import InputField from "@_common/InputRuleFeild";
import { sanitizeInput } from "@_common/dompurify";

interface ILoginPageProps {}

const LoginPage: React.FunctionComponent<ILoginPageProps> = (props: any) => {
	/* -------------------------------------------------------------------------- */
	/*                               UseState Section                             */
	/* -------------------------------------------------------------------------- */
	const simpleValidator = useRef(new SimpleReactValidator());
	const [, forceUpdate] = useState(0);

	const [isLoading, setIsLoading] = useState(false);
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [user_type] = useState("VENDOR");

	/* -------------------------------------------------------------------------- */
	/*                               UseEffect Section                            */
	/* -------------------------------------------------------------------------- */
	/* -------------------------------------------------------------------------- */
	/*                               API Section                                  */
	/* -------------------------------------------------------------------------- */

	const handleSubmit = async () => {
		const formValid = simpleValidator.current.allValid();
		if (!formValid) {
			simpleValidator.current.showMessages();
			forceUpdate(1);
		} else {
			try {
				setIsLoading(true);
				let resp = await adminLogin({ email, password, user_type });
				if (resp) {
					setIsLoading(false);
					localStorage.setItem(
						"accessToken",
						getValue(resp, `data.accessToken`, "")
					);
					localStorage.setItem(
						"refreshToken",
						getValue(resp, `data.refreshToken`, "")
					);
					localStorage.setItem(
						"user",
						JSON.stringify(getValue(resp, `data.user`, ""))
					);
					window.location.href = `/dashboard/self-compliance/my-activity`;
					// console.log(resp);
				} else {
					setIsLoading(false);
				}
			} catch (error) {
				setIsLoading(false);
			}
		}
	};

	/* -------------------------------------------------------------------------- */
	/*                               Onchange section                             */
	/* -------------------------------------------------------------------------- */
	return (
		<>
			<LoginPageLyout>
				<div className="m-auto form-wrapper__form">
					<h2>Sign in to Lexcare (Vendor)</h2>
					<div className="form-group">
						<label htmlFor="email">Email</label>
						<InputField
							inputType="TEXT"
							id="email"
							name="email"
							value={email}
							onChange={(e: any) => setEmail(sanitizeInput(e.target.value))}
							placeholder="Enter Email"
							className="form-control"
							label="Email"
							validator={simpleValidator}
						/>
					</div>
					<div className="form-group">
						<label>Password</label>
						<InputField
							inputType="PASSWORD"
							id="password"
							name="password"
							value={password}
							onChange={(e: any) => setPassword(e.target.value)}
							placeholder="Enter Password"
							className="form-control"
							validator={simpleValidator}
							label={"Password"}
						/>
					</div>
					<div className="form-cta-button">
						<NavLink to="/auth/vendor/forgot-password">
							<button className="form-cta-button__secondary-btn">
								Forgot password?
							</button>
						</NavLink>
						{isLoading ? (
							<button className="form-cta-button__primary-btn">
								Please wait...
							</button>
						) : (
							<button
								onClick={handleSubmit}
								className="form-cta-button__primary-btn"
							>
								Next
							</button>
						)}
					</div>
					<br />
					<NavLink to="/login">Sign-in as Client </NavLink>
				</div>
			</LoginPageLyout>
		</>
	);
};

export default LoginPage;
